import { cva } from 'class-variance-authority';

export const cvaRoot = cva(['RatingStyles-cvaRoot', 'flex']);

export const cvaItem = cva(['RatingStyles-cvaItem', 'flex items-center justify-center'], {
  variants: {
    size: {
      large: ['w-3.1 h-3.1'],
      small: ['w-2.4 h-2.4'],
    },
    selectable: {
      true: ['cursor-pointer'],
      false: [''],
    },
  },
  defaultVariants: {
    size: 'large',
    selectable: false,
  },
});

export const cvaItemSvg = cva(['RatingStyles-cvaItemSvg', ''], {
  variants: {
    size: {
      large: ['w-2.4 h-2.4'],
      small: ['w-1.8 h-1.8'],
    },
  },
  defaultVariants: {
    size: 'large',
  },
});
